module.exports = __webpack_public_path__ + "icon-facebook-1eaae33ae7bb4abb43c11800e0e93a3d.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/bundles/ui/SharePhotoModal/ShareLink/icon-facebook.svg
// module id = 1630
// module chunks = 3 6